"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _constants = require("@seedlang/constants");
var _layouts = require("@seedlang/layouts");
var _models = require("@seedlang/models");
var _stores = require("@seedlang/stores");
var _utils = require("@seedlang/utils");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _lodash = require("lodash");
var _mobx = require("mobx");
var _serializr = require("serializr");
var _exercise_ui = _interopRequireDefault(require("./exercise_ui"));
var _overlay_ui = _interopRequireDefault(require("./overlay_ui"));
var _root_state = _interopRequireDefault(require("./root_state"));
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DeckUI = (_class = /*#__PURE__*/function (_RootState) {
  function DeckUI() {
    var _this;
    _classCallCheck(this, DeckUI);
    _this = _callSuper(this, DeckUI);
    _initializerDefineProperty(_this, "cardSeenCount", _descriptor, _this);
    _initializerDefineProperty(_this, "wordClickCount", _descriptor2, _this);
    _initializerDefineProperty(_this, "seenConceptDescription", _descriptor3, _this);
    _initializerDefineProperty(_this, "selectedConceptDescriptionOpen", _descriptor4, _this);
    _initializerDefineProperty(_this, "cardNotice", _descriptor5, _this);
    _initializerDefineProperty(_this, "showCloseModal", _descriptor6, _this);
    _initializerDefineProperty(_this, "animationQueue", _descriptor7, _this);
    _initializerDefineProperty(_this, "lastFeedEntryId", _descriptor8, _this);
    _initializerDefineProperty(_this, "dataSaverModalSeen", _descriptor9, _this);
    _initializerDefineProperty(_this, "enrichedTranslations", _descriptor10, _this);
    _initializerDefineProperty(_this, "overlayExpanded", _descriptor11, _this);
    _initializerDefineProperty(_this, "sound", _descriptor12, _this);
    _initializerDefineProperty(_this, "textRevealed", _descriptor13, _this);
    _initializerDefineProperty(_this, "arrowBoxIsHidden", _descriptor14, _this);
    _initializerDefineProperty(_this, "cardIsAnimating", _descriptor15, _this);
    _initializerDefineProperty(_this, "firstCardHasAdvanced", _descriptor16, _this);
    _initializerDefineProperty(_this, "mediaStores", _descriptor17, _this);
    _initializerDefineProperty(_this, "userInputStores", _descriptor18, _this);
    _initializerDefineProperty(_this, "shortcutsAssigned", _descriptor19, _this);
    _initializerDefineProperty(_this, "animationCards", _descriptor20, _this);
    _initializerDefineProperty(_this, "deviceDeniedAccess", _descriptor21, _this);
    _initializerDefineProperty(_this, "showSlowDeckLoadingWarning", _descriptor22, _this);
    _initializerDefineProperty(_this, "localDeck", _descriptor23, _this);
    _initializerDefineProperty(_this, "localUserDeck", _descriptor24, _this);
    _initializerDefineProperty(_this, "hideCardIcons", _descriptor25, _this);
    _initializerDefineProperty(_this, "warning", _descriptor26, _this);
    _initializerDefineProperty(_this, "showCorrectAnswer", _descriptor27, _this);
    _initializerDefineProperty(_this, "reviewCards", _descriptor28, _this);
    _this.soundEffectStore = _stores.SoundEffectStore;
    _this.xpState = _models.XpState;
    _this.deckStore = _stores.DeckStore;
    _this.cardStore = _stores.CardStore;
    _this.eventStore = _stores.EventStore;
    _this.authUserStore = _stores.AuthUserStore;
    _this.levelStore = _stores.LevelStore;
    _this.conceptStore = _stores.ConceptStore;
    _this.userTranslationStore = _stores.UserTranslationStore;
    _this.userConceptStore = _stores.UserConceptStore;
    _this.pageStore = _stores.PageStore;
    _this.layout = new _layouts.DeckLayout(_this);
    _this.feedEntryStore = _stores.FeedEntryStore;
    _this.wordStore = _stores.WordStore;
    _this.wordSentenceStore = _stores.WordSentenceStore;
    _this.conceptSentenceStore = _stores.ConceptSentenceStore;
    _this.routeStore = _stores.RouteStore;
    _this.deckFeedEntryStore = _stores.DeckFeedEntryStore;
    _this.wordTypeStore = _stores.WordTypeStore;
    _this.userDeckStore = _stores.UserDeckStore;
    _this.userCardStore = _stores.UserCardStore;
    _this.translationSourceStore = _stores.TranslationSourceStore;
    _this.sentenceStore = _stores.SentenceStore;
    _this.conceptWordStore = _stores.ConceptWordStore;
    _this.reviewStore = _stores.ReviewStore;
    _this.targetLanguageStore = _stores.TargetLanguageStore;
    _this.loadDeckStartTime;
    _this.onNewDeck();
    (0, _mobx.autorun)(function () {
      if (_this.mediaBlocked) {
        _this.pauseMedia();
      }
    });
    return _this;
  }
  _inherits(DeckUI, _RootState);
  return _createClass(DeckUI, [{
    key: "user",
    get: function get() {
      return this.authUserStore.showData;
    }
  }, {
    key: "treeNodeId",
    get: function get() {
      if (this.deck && this.deck.treeNodeIds) {
        return this.deck.treeNodeIds.split(',')[0];
      }
    }
  }, {
    key: "deck",
    get: function get() {
      return this.deckStore.showData;
    }
  }, {
    key: "deckState",
    get: function get() {
      return this.deck.deckState;
    }
  }, {
    key: "userDeck",
    get: function get() {
      return this.userDeckStore.showData;
    }
  }, {
    key: "currentCard",
    get: function get() {
      var _this$deck$cards,
        _this2 = this;
      return this.deckLoaded ? (_this$deck$cards = this.deck.cards) === null || _this$deck$cards === void 0 ? void 0 : _this$deck$cards.find(function (item) {
        return item.id === _this2.userDeck.currentCardId;
      }) : {};
    }
  }, {
    key: "currentUserCard",
    get: function get() {
      var _this3 = this;
      return (0, _utils.isPresent)(this.userDeck) ? this.userDeck.userCards.find(function (item) {
        return item.cardId === _this3.userDeck.currentCardId;
      }) : {};
    }
  }, {
    key: "currentCardState",
    get: function get() {
      return (0, _utils.isPresent)(this.currentCard) ? this.currentCard.cardState : {};
    }
  }, {
    key: "siteIsDefault",
    get: function get() {
      if (this.layout.isNative) {
        return true;
      } else if ((0, _utils.isPresent)(this.site)) {
        return this.site.isDefault;
      }
      return this.siteIsDefaultFromUrl;
    }
  }, {
    key: "site",
    get: function get() {
      var _this$user;
      return (_this$user = this.user) === null || _this$user === void 0 ? void 0 : _this$user.site;
    }
  }, {
    key: "targetLanguageId",
    get: function get() {
      if (!this.siteIsDefault && (0, _utils.isPresent)(this.site)) {
        return this.site.languageId;
      } else if (this.updatedDeviceLanguageId && this.updatedDeviceLanguageId !== 'all') {
        return this.updatedDeviceLanguageId;
      } else if (this.layout.deviceLanguageId && this.layout.deviceLanguageId !== 'all') {
        return this.layout.deviceLanguageId;
      } else if (this.userIsLoaded) {
        return this.user.targetLanguageId;
      }
      return 'DE';
    }
  }, {
    key: "targetLanguage",
    get: function get() {
      var _this4 = this;
      if (!this.userIsLoaded) {
        return {};
      }
      var tl = this.user.targetLanguages.find(function (item) {
        return item.languageId === _this4.targetLanguageId;
      });
      return tl || this.user.defaultTargetLanguage;
    }
  }, {
    key: "routeToOnClose",
    get: function get() {
      if (this.deck.triviaDeck && (!this.treeNodeId || _constants.Constants.TRIVIA_TREE_NODES.includes(this.treeNodeId))) {
        return 'trivia.home';
      }
      if (this.storyDeck || this.treeNodeId && !_constants.Constants.TRIVIA_TREE_NODES.includes(this.treeNodeId)) {
        return 'stories.home';
      }
      if (this.vocabDeck || this.deck.pluralDeck || this.deck.genderDeck || this.deck.conjugationDeck || this.deck.numberDeck) {
        return 'vocab.home';
      }
      return 'review.home';
    }
  }, {
    key: "userInputStore",
    get: function get() {
      return this.currentCard && this.userInputStores[this.currentCard.id] ? this.userInputStores[this.currentCard.id] : {};
    }
  }, {
    key: "mediaStore",
    get: function get() {
      return this.currentCard && this.mediaStores[this.currentCard.id] ? this.mediaStores[this.currentCard.id] : {};
    }
  }, {
    key: "clearAudioStreams",
    value: function clearAudioStreams() {
      (0, _lodash.each)(this.mediaStores, function (store) {
        store.clearAudioStream();
      });
    }
  }, {
    key: "commentDebugInfo",
    get: function get() {
      return {
        deckInfo: this.debugInfo['deckInfo'],
        card: this.debugInfo['cards'].find(function (item) {
          return item.active;
        }),
        userInfo: this.debugInfo['userInfo']
      };
    }
  }, {
    key: "debugInfo",
    get: function get() {
      var _this5 = this;
      var hsh = {
        userInfo: {
          version: this.user.lastWebVersionDownloaded,
          isNative: this.layout.isNative ? '✓' : 'x',
          targetLanguage: this.targetLanguageId,
          deviceOs: this.layout.deviceOs,
          osVersion: this.layout.osVersion,
          deviceName: this.layout.deviceName,
          viewportWidth: this.layout.viewportWidth,
          viewportHeight: this.layout.viewportHeight,
          hasNotch: this.layout.hasNotch ? '✓' : 'x',
          statusBarHeight: this.layout.statusBarHeight,
          blockMediaAccess: this.user.blockMediaAccess ? '✓' : 'x',
          vocabCardAudio: this.user.vocabCardAudio ? '✓' : 'x',
          listeningComprehensionMode: this.user.listeningComprehensionMode ? '✓' : 'x',
          loopSupplement: this.user.loopSupplement ? '✓' : 'x',
          supplementMaximized: this.user.supplementMaximized ? '✓' : 'x',
          showCardAnimation: this.user.showCardAnimation ? '✓' : 'x',
          currentDayXp: this.user.currentDayXp
        },
        deckInfo: {
          deckType: this.hasDeck && this.deck.deckRulebook && this.deck.deckRulebook.slug || 'review',
          deckId: this.hasDeck ? this.deck.id : null,
          deckName: this.hasDeck ? this.deck.name : null,
          treeNodeId: this.treeNodeId,
          inTree: (0, _utils.isPresent)(this.treeNodeId),
          userDeckId: this.userDeck && this.userDeck.id,
          active: this.userDeck && this.userDeck.userCards && this.userDeck.userCards.map(function (item) {
            return item.active ? '✓' : 'x';
          }).join(', '),
          seen: this.userDeck && this.userDeck.userCards && this.userDeck.userCards.map(function (item) {
            return item.seen ? '✓' : 'x';
          }).join(', '),
          correct: this.userDeck && this.userDeck.userCards && this.userDeck.userCards.map(function (item) {
            return item.correct ? '✓' : 'x';
          }).join(', '),
          completed: this.userDeck && this.userDeck.userCards && this.userDeck.userCards.map(function (item) {
            return item.completed ? '✓' : 'x';
          }).join(', '),
          position: this.userDeck && this.userDeck.userCards && this.userDeck.userCards.map(function (item) {
            return item.position;
          }).join(','),
          enriched: this.userDeck && this.userDeck.userCards && this.deck.cards.map(function (item) {
            return item.isEnriched ? '✓' : 'x';
          }).join(',')
        },
        cards: [],
        animationCards: []
      };
      (0, _lodash.each)(this.deck.cards, function (item) {
        var translation;
        if (item.translation && item.translation.targetText) {
          translation = item.translation.targetText;
        } else if (item && item.exerciseId && _this5.deck) {
          var exercise = _this5.deck.exercises.find(function (exercise) {
            return exercise.id === item.exerciseId;
          });
          if ((0, _utils.isPresent)(exercise.exerciseEntries)) {
            var _exercise$exerciseEnt;
            translation = exercise === null || exercise === void 0 || (_exercise$exerciseEnt = exercise.exerciseEntries[0]) === null || _exercise$exerciseEnt === void 0 || (_exercise$exerciseEnt = _exercise$exerciseEnt.sentence) === null || _exercise$exerciseEnt === void 0 ? void 0 : _exercise$exerciseEnt.targetText;
          }
        }
        var userCard;
        if ((0, _utils.isPresent)(_this5.userDeck)) {
          userCard = _this5.userDeck.userCards.find(function (uc) {
            return uc.cardId === item.id;
          });
        }
        hsh.cards.push(_objectSpread(_objectSpread(_objectSpread({
          id: item.id,
          position: item.position,
          translation: translation,
          cardTypeId: item.cardType.id,
          cardTypeSlug: item.cardType.slug
        }, (0, _utils.isPresent)(item.sourceDeckId) && {
          source_deck_id: item.sourceDeckId
        }), {}, {
          correct: userCard && userCard.correct,
          active: userCard && userCard.active,
          completed: userCard && userCard.completed,
          interfaceSource: item.interfaceSource
        }, (0, _utils.isPresent)(item.cardState.textEntry) && {
          text_entry: item.cardState.textEntry
        }), (0, _utils.isPresent)(item.cardState.inputValues) && {
          input_values: (0, _lodash.values)(item.cardState.inputValues).join(', ')
        }));
      });
      (0, _lodash.each)(this.animationCards, function (item) {
        var translation;
        var translationId;
        var translationType;
        var selectedWordAssociations;
        if (item.card && item.card.translation && item.card.translation.targetText) {
          translation = item.card.translation.targetText;
          translationId = item.card.translation.id;
          translationType = item.card.translationType;
          if ((0, _utils.isPresent)(item.card.wordAssociationIds) && (0, _utils.isPresent)(item.card.translation.wordAssociations)) {
            selectedWordAssociations = item.card.translation.wordAssociations.filter(function (wordAssociation) {
              return item.card.wordAssociationIds.includes(wordAssociation.id);
            });
          }
        } else if (item.card && item.card.exerciseId && _this5.deck) {
          var exercise = _this5.deck.exercises.find(function (exercise) {
            return exercise.id === item.card.exerciseId;
          });
          if ((0, _utils.isPresent)(exercise.exerciseEntries)) {
            var _exercise$exerciseEnt2;
            translation = exercise === null || exercise === void 0 || (_exercise$exerciseEnt2 = exercise.exerciseEntries[0]) === null || _exercise$exerciseEnt2 === void 0 || (_exercise$exerciseEnt2 = _exercise$exerciseEnt2.sentence) === null || _exercise$exerciseEnt2 === void 0 ? void 0 : _exercise$exerciseEnt2.targetText;
          }
        }
        hsh.animationCards.push(_objectSpread({
          position: item.position,
          cardId: item.card.id,
          userCardId: item.userCard.id,
          userCardPosition: item.userCard.position,
          userCardActive: item.userCard.active ? '✓' : 'x',
          cardType: item.userCard.cardRule.cardType.slug,
          translation: translation,
          translationId: translationId,
          translationType: translationType
        }, (0, _utils.isPresent)(selectedWordAssociations) && {
          selected_word_associations: selectedWordAssociations.map(function (item) {
            return item.targetText;
          }).join(', ')
        }));
      });
      return hsh;
    }
  }, {
    key: "wordSentences",
    get: function get() {
      return this.wordSentenceStore.indexData;
    }
  }, {
    key: "userIsLoaded",
    get: function get() {
      return (0, _utils.isPresent)(this.user.id);
    }
  }, {
    key: "hasDeck",
    get: function get() {
      return (0, _utils.isPresent)(this.deck);
    }
  }, {
    key: "hasUserDeck",
    get: function get() {
      return (0, _utils.isPresent)(this.userDeck);
    }
  }, {
    key: "hasCurrentCard",
    get: function get() {
      return (0, _utils.isPresent)(this.currentCard);
    }

    // DECK STATE
  }, {
    key: "showCorrectCardStatus",
    get: function get() {
      return false;
    }
  }, {
    key: "levelIncremented",
    get: function get() {
      return this.deckState && this.deckState.currentAnimation === 'levelIncremented';
    }
  }, {
    key: "setCardIsAnimating",
    value: function setCardIsAnimating(cardIsAnimating) {
      this.cardIsAnimating = cardIsAnimating;
      if (!cardIsAnimating) {
        this.firstCardHasAdvanced = true;
        this.arrowBoxIsHidden = false;
      }
    }
  }, {
    key: "setSkipCardAnimation",
    value: function setSkipCardAnimation(skipCardAnimation) {
      this.skipCardAnimation = skipCardAnimation;
    }
  }, {
    key: "assignShortcut",
    value: function assignShortcut(shortcut) {
      if (!this.isShortcutAssigned(shortcut)) {
        this.shortcutsAssigned.push(shortcut);
      }
    }
  }, {
    key: "removeShortcut",
    value: function removeShortcut(shortcut) {
      this.shortcutsAssigned = (0, _lodash.without)(this.shortcutsAssigned, shortcut);
    }
  }, {
    key: "isShortcutAssigned",
    value: function isShortcutAssigned(shortcut) {
      return this.shortcutsAssigned.includes(shortcut);
    }
  }, {
    key: "skipAnimationGotoLastCard",
    value: function skipAnimationGotoLastCard() {
      this.onSoftReset();
      this.setSkipCardAnimation(true);
      this.gotoPreviousCard();
    }
  }, {
    key: "skipAnimationNextCard",
    value: function skipAnimationNextCard() {
      if (!this.isLastCard) {
        this.onSoftReset();
        this.setSkipCardAnimation(true);
        this.currentUserCard.set('currentCorrect', true);
        this.currentUserCard.set('correct', true);
        this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard, {
          active: false,
          forceAdvancement: true
        });
      }
    }
  }, {
    key: "vocabSectionHeight",
    get: function get() {
      var height = this.wordOptionsCard ? this.layout.contentHeight - this.layout.userInputHeight : this.layout.contentHeight;
      return Math.floor(height / this.numVocabSections);
    }
  }, {
    key: "numVocabSections",
    get: function get() {
      return this.wordOptionsCard || this.vocabSentenceTranslateAudioCard && !this.currentCardRevealed ? 2 : 3;
    }
  }, {
    key: "vocabTextHeight",
    get: function get() {
      return this.vocabSectionHeight - 20;
    }
  }, {
    key: "onToggleReview",
    value: function onToggleReview(card, reviewDeckId) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (card.cardState && !params.hideMessage) {
        card.cardState.set('addToReviews', !(card.cardState.addToReviews || (0, _utils.isPresent)(this.reviewCard(card))));
      }
      if ((0, _utils.isPresent)(this.reviewCard(card, reviewDeckId))) {
        this.cardStore.destroy({
          ids: {
            cardId: this.reviewCard(card, reviewDeckId).id
          }
        });
        this.removeCardFromReviewCards(card, reviewDeckId);
        card === null || card === void 0 || card.set('reviewCardId', null);
      } else {
        var _card$word;
        this.user.set('reviewCardsCount', this.user.reviewCardsCount + 1);
        card.set('reviewCardId', '999');
        (_card$word = card.word) === null || _card$word === void 0 || _card$word.set('reviewing', true);
        this.addCardToReviewCards(card, reviewDeckId);
        this.cardStore.create({
          data: {
            source_card_id: card.id,
            deck_id: reviewDeckId,
            language_id: this.deck.languageId
          }
        }, this.afterCreateReview.bind(this, card, reviewDeckId));
      }
    }
  }, {
    key: "getReviewCards",
    value: function getReviewCards() {
      if (!this.reviewDeck) {
        this.cardStore.getIndex({
          queryStrings: {
            reviews_for_deck_id: this.deck.id
          }
        }, this.afterGetReviewCards);
      }
    }
  }, {
    key: "afterGetReviewCards",
    value: function afterGetReviewCards(resp) {
      this.reviewCards = resp.map(function (item) {
        var _item$word, _item$sentence, _item$word2, _item$sentence2, _item$cardType;
        return {
          id: item.id,
          translationId: ((_item$word = item.word) === null || _item$word === void 0 ? void 0 : _item$word.id) || ((_item$sentence = item.sentence) === null || _item$sentence === void 0 ? void 0 : _item$sentence.id),
          wordId: (_item$word2 = item.word) === null || _item$word2 === void 0 ? void 0 : _item$word2.id,
          sentenceId: (_item$sentence2 = item.sentence) === null || _item$sentence2 === void 0 ? void 0 : _item$sentence2.id,
          cardTypeId: (_item$cardType = item.cardType) === null || _item$cardType === void 0 ? void 0 : _item$cardType.id,
          deckId: item.deckId,
          pronoun: item.pronoun,
          tenseConceptId: item.tenseConceptId,
          wordAssociationIds: item.wordAssociationIds,
          sourceCardId: item.sourceCardId,
          exerciseId: item.exerciseId
        };
      });
    }
  }, {
    key: "reviewCard",
    value: function reviewCard(card, deckId) {
      var _this$reviewCards;
      var reviewCards = (_this$reviewCards = this.reviewCards) === null || _this$reviewCards === void 0 ? void 0 : _this$reviewCards.filter(function (item) {
        var _card$translation, _card$translation2, _card$exercise, _card$translation3;
        return (item.wordId === ((_card$translation = card.translation) === null || _card$translation === void 0 ? void 0 : _card$translation.id) || item.sentenceId === ((_card$translation2 = card.translation) === null || _card$translation2 === void 0 ? void 0 : _card$translation2.id) || item.exerciseId === ((_card$exercise = card.exercise) === null || _card$exercise === void 0 ? void 0 : _card$exercise.id) || item.translationId === ((_card$translation3 = card.translation) === null || _card$translation3 === void 0 ? void 0 : _card$translation3.id)) && item.cardTypeId === card.cardTypeId && item.pronoun === card.pronoun && item.tenseConceptId === card.tenseConceptId;
      });
      if ((0, _utils.isPresent)(deckId)) {
        return reviewCards === null || reviewCards === void 0 ? void 0 : reviewCards.find(function (item) {
          return item.deckId === deckId;
        });
      }
      if ((0, _utils.isPresent)(reviewCards)) {
        return reviewCards[0];
      }
    }
  }, {
    key: "createEvent",
    value: function createEvent(eventType, params) {
      this.eventStore.create({
        data: {
          eventType: eventType,
          params: params
        }
      }, _lodash.noop);
    }
  }, {
    key: "addCardToReviewCards",
    value: function addCardToReviewCards(card, deckId) {
      var _card$translation4, _card$cardType;
      if (this.reviewCard(card, card.deckId)) {
        return;
      }
      this.reviewCards.push({
        id: '999',
        // temp ID before returned from server
        translationId: (_card$translation4 = card.translation) === null || _card$translation4 === void 0 ? void 0 : _card$translation4.id,
        cardTypeId: (_card$cardType = card.cardType) === null || _card$cardType === void 0 ? void 0 : _card$cardType.id,
        deckId: deckId || this.deck.id,
        pronoun: card.pronoun,
        tenseConceptId: card.tenseConceptId,
        wordAssociationIds: card.wordAssociationIds,
        exerciseId: card.exerciseId
      });
    }
  }, {
    key: "removeCardFromReviewCards",
    value: function removeCardFromReviewCards(card, deckId) {
      var _card$word2, _card$sentence;
      if (!this.reviewCard(card, deckId)) {
        return;
      }
      var translationId = ((_card$word2 = card.word) === null || _card$word2 === void 0 ? void 0 : _card$word2.id) || ((_card$sentence = card.sentence) === null || _card$sentence === void 0 ? void 0 : _card$sentence.id);
      (0, _lodash.remove)(this.reviewCards, function (item) {
        return item.translationId === translationId && item.deckId === deckId && item.cardTypeId === card.cardType.id && item.pronoun === card.pronoun && item.tenseConceptId === card.tenseConceptId && item.exerciseId === card.exerciseId;
      });
    }
  }, {
    key: "afterCreateReview",
    value: function afterCreateReview(card, deckId, resp) {
      var _card$word3, _card$sentence2;
      card.set('reviewCardId', resp.cardId);
      var cardTranslationId = ((_card$word3 = card.word) === null || _card$word3 === void 0 ? void 0 : _card$word3.id) || ((_card$sentence2 = card.sentence) === null || _card$sentence2 === void 0 ? void 0 : _card$sentence2.id);
      (0, _lodash.each)(this.reviewCards, function (item) {
        item.translationId === cardTranslationId && item.deckId === deckId && item.cardTypeId === card.cardTypeId ? item['id'] = resp.cardId : _lodash.noop;
      });
    }
  }, {
    key: "normalizeString",
    value: function normalizeString(string) {
      var forceLowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if ((0, _utils.isBlank)(string)) {
        return;
      }
      var str = (0, _utils.normalizeCharacters)(string);
      if (this.deck.languageId === 'DE') {
        str = str.replace(/é/g, 'e').replace(/É/g, 'E');
      }
      if (this.user.enforceCasing && !forceLowerCase) {
        return str;
      }
      return str.toLowerCase();
    }
  }, {
    key: "getEvaluateTextInputMatch",
    value: function getEvaluateTextInputMatch(word, cardState) {
      var lowerCase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var localNormalizedTextEntry = word ? this.normalizeString(cardState.textEntry, lowerCase) : null;
      var matchTargetTextWithDefiniteArticle = word && cardState.textEntry && localNormalizedTextEntry === this.normalizeString(word.targetTextWithDefiniteArticle, lowerCase);
      var matchTargetTextWithDefiniteArticleNoParenthesis = word && cardState.textEntry && localNormalizedTextEntry === this.normalizeString(word.targetTextWithDefiniteArticleNoParenthesis, lowerCase);
      var matchTargetTextWithoutDefiniteArticle = word && cardState.textEntry && word.useParenthesesOnGender && localNormalizedTextEntry === this.normalizeString(word.targetText, lowerCase);
      var matchHundertOrTausendPlusEin = word && word.isNumber && cardState.textEntry && (word.targetText.startsWith('hundert') || word.targetText.startsWith('tausend')) && localNormalizedTextEntry.replace(/^ein/, '') === this.normalizeString(word.targetText, lowerCase);
      var matchEinhundertOrEintausendWithoutEin = word && word.isNumber && cardState.textEntry && (word.targetText.startsWith('einhundert') || word.targetText.startsWith('eintausend')) && localNormalizedTextEntry === this.normalizeString(word.targetText, lowerCase).replace(/^ein/, '');
      return matchTargetTextWithDefiniteArticle || matchTargetTextWithDefiniteArticleNoParenthesis || matchTargetTextWithoutDefiniteArticle || matchHundertOrTausendPlusEin || matchEinhundertOrEintausendWithoutEin;
    }
  }, {
    key: "textEntryMatchesSynonym",
    value: function textEntryMatchesSynonym(word, cardState) {
      var _this6 = this;
      if ((0, _utils.isBlank)(word.synonymAssociations) || (0, _utils.isBlank)(cardState.textEntry)) {
        return;
      }
      return (0, _lodash.some)(word.synonymAssociations.map(function (item) {
        return _this6.getEvaluateTextInputMatch(item.synonym, cardState);
      }));
    }
  }, {
    key: "onEvaluateTextInput",
    value: function onEvaluateTextInput(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      userCard.set('correct', false);
      userCard.set('firstAnswerCorrect', false);
      this.vocabStuckClicked = false;
      var word = card.word;
      var normalizedTextEntry = word ? this.normalizeString(cardState.textEntry) : null;
      var match = this.getEvaluateTextInputMatch(word, cardState);
      var correct = (card.vocabWordTranslateCard || card.numberTranslateCard) && match;
      var noAccentMatch;
      var missingArticle;
      var wrongArticle;
      if ((0, _utils.isPresent)(word)) {
        noAccentMatch = !correct && !this.user.strictMatch && word && cardState.textEntry && (0, _utils.isPresent)(normalizedTextEntry) && ((0, _lodash.deburr)(normalizedTextEntry.replace('-', ' ')) === (0, _lodash.deburr)(this.normalizeString(word.targetTextWithDefiniteArticle).replace(/-/g, ' ')) || word.useParenthesesOnGender && (0, _lodash.deburr)(normalizedTextEntry) === (0, _lodash.deburr)(this.normalizeString(word.targetText)));

        // check if article is missing
        var articles = (0, _lodash.uniq)((0, _lodash.values)(_constants.Constants.SINGULAR_ARTICLES[word.languageId]).concat((0, _lodash.values)(_constants.Constants.PLURAL_ARTICLES[word.languageId])));
        var maxArticleLength = Math.max.apply(Math, _toConsumableArray(articles.map(function (item) {
          return item.length;
        })));
        var pattern;
        if (word.languageId === 'FR') {
          pattern = new RegExp("^((".concat(articles.join('|'), ")\\s+|l'|l\u2019|l\u2018)"));
        } else {
          pattern = new RegExp("^(".concat(articles.join('|'), ")\\s+"));
        }
        missingArticle = word && word.isNoun && !(word.useParenthesesOnGender || word.articleIsHidden) && cardState.textEntry.length > maxArticleLength && !pattern.test(cardState.textEntry.toLowerCase());
        wrongArticle = word && word.isNoun && !correct && !missingArticle && (0, _utils.isPresent)(normalizedTextEntry) && normalizedTextEntry.replace(pattern, '') === this.normalizeString(word.targetText);
      }
      var allLowerCaseMatch = !correct && this.getEvaluateTextInputMatch(word, cardState, true);

      // warning messages stored in constants.js
      if ((0, _utils.isPresent)(word)) {
        if (missingArticle) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'missingArticle' ? '' : 'missingArticle';
        } else if (wrongArticle) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'wrongArticle' ? '' : 'wrongArticle';
        } else if (noAccentMatch) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'accents' ? '' : 'accents';
        } else if (this.textEntryMatchesSynonym(word, cardState)) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'synonym' ? '' : 'synonym';
        } else if (allLowerCaseMatch) {
          this.warning = !params.onlyRevealOnCorrect && this.warning === 'letterCase' ? '' : 'letterCase';
        } else {
          this.warning = '';
        }
      }
      if (correct) {
        this.warning = '';
        this.onCorrectAnswer(card, cardState, userCard, {
          xp: 2
        });
      } else if (!params.onlyRevealOnCorrect && (0, _utils.isBlank)(this.warning)) {
        this.onIncorrectAnswer(card, cardState, userCard);
      }
      if ((!params.onlyRevealOnCorrect || correct) && (0, _utils.isBlank)(this.warning)) {
        this.reveal(card, cardState);
      }
      if (correct && normalizedTextEntry !== this.normalizeString(word.targetTextWithDefiniteArticle) && normalizedTextEntry !== this.normalizeString(word.targetTextWithDefiniteArticleNoParenthesis) && normalizedTextEntry !== this.normalizeString(word.targetText)) {
        this.showCorrectAnswer = true;
      } else {
        this.showCorrectAnswer = false;
      }
    }
  }, {
    key: "onWordInputChange",
    value: function onWordInputChange(cardState, val) {
      if (cardState) {
        val = val.replace('’', '\'');
        cardState.set('textEntry', val);
      }
    }
  }, {
    key: "onWordInputChangeAndEvaluate",
    value: function onWordInputChangeAndEvaluate(card, cardState, userCard, val) {
      if (cardState) {
        val = val.replace('’', '\'');
        cardState.set('textEntry', val);
      }
      this.onEvaluateTextInput(card, cardState, userCard, {
        onlyRevealOnCorrect: true
      });
    }

    // ephemeral cards
  }, {
    key: "checkpointCard",
    get: function get() {
      return this.currentCardSlug === 'checkpoint_card';
    }
  }, {
    key: "wordOptionsCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_word_options';
    }

    // static cards
  }, {
    key: "deckSummaryCard",
    get: function get() {
      return this.currentCardSlug === 'deck_summary';
    }
  }, {
    key: "triviaCard",
    get: function get() {
      return this.currentCardSlug === 'trivia';
    }
  }, {
    key: "genderCard",
    get: function get() {
      return this.currentCardSlug === 'gender';
    }
  }, {
    key: "genderResultsCard",
    get: function get() {
      return this.currentCardSlug === 'gender-results';
    }
  }, {
    key: "conjugationResultsCard",
    get: function get() {
      return this.currentCardSlug === 'conjugation-results';
    }
  }, {
    key: "pluralCard",
    get: function get() {
      return this.currentCardSlug === 'plural';
    }
  }, {
    key: "pluralResultsCard",
    get: function get() {
      return this.currentCardSlug === 'plural-results';
    }
  }, {
    key: "numberResultsCard",
    get: function get() {
      return this.currentCardSlug === 'number-results';
    }
  }, {
    key: "triviaIntroCard",
    get: function get() {
      return this.currentCardSlug === 'trivia-intro';
    }
  }, {
    key: "triviaResultsCard",
    get: function get() {
      return this.currentCardSlug === 'trivia-results';
    }
  }, {
    key: "describeCard",
    get: function get() {
      return this.currentCardSlug === 'record_description';
    }
  }, {
    key: "answerCard",
    get: function get() {
      return this.currentCardSlug === 'record_answer';
    }
  }, {
    key: "comprehendCard",
    get: function get() {
      return this.currentCardSlug === 'comprehend';
    }
  }, {
    key: "translateCard",
    get: function get() {
      return this.currentCardSlug === 'translate';
    }
  }, {
    key: "exerciseCard",
    get: function get() {
      return this.currentCardSlug === 'exercise';
    }
  }, {
    key: "vocabWordComprehendCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_word_comprehend';
    }
  }, {
    key: "vocabSentenceTranslateCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_sentence_translate';
    }
  }, {
    key: "vocabSentenceComprehendCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_sentence_comprehend';
    }
  }, {
    key: "vocabSentenceTranslateAudioCard",
    get: function get() {
      return this.vocabSentenceTranslateCard && this.vocabCardUsesAudio;
    }

    // ---------------
  }, {
    key: "userDeckGenderCards",
    get: function get() {
      var ids = this.deck.genderCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "userDeckPluralCards",
    get: function get() {
      var ids = this.deck.pluralCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "userDeckNumberCards",
    get: function get() {
      var ids = this.deck.numberCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "userDeckTriviaCards",
    get: function get() {
      var ids = this.deck.triviaCards.map(function (item) {
        return item.id;
      });
      return this.userDeck.userCards.filter(function (item) {
        return ids.includes(item.cardId);
      });
    }
  }, {
    key: "deviceType",
    get: function get() {
      if (this.layout.isAndroid) {
        return 'android';
      } else if (this.layout.isIos) {
        return 'ios';
      }
      return 'web';
    }
  }, {
    key: "loadDeck",
    value: function loadDeck(params) {
      var _this7 = this;
      this.onNewDeck();
      this.onReset();
      this.deckStore.clearShowData();
      this.userDeckStore.clearShowData();
      clearTimeout(this.checkLoadTimeTimeout);
      this.checkLoadTimeTimeout = setTimeout(function () {
        return _this7.checkDeckLoadTime();
      }, _constants.Constants.TIME_BEFORE_SLOW_DECK_WARNING);
      this.loadDeckStartTime = performance.now();
      this.deckStore.getShow({
        ids: {
          deckId: params.id
        },
        queryStrings: {
          device: this.deviceType,
          tree_node_id: params.treeNodeId
        }
      }, this.afterLoadDeck.bind(this, params.userDeckId, params.opponentId, params.callback || _lodash.noop));
    }
  }, {
    key: "checkDeckLoadTime",
    value: function checkDeckLoadTime() {
      if (!this.hasDeck) {
        this.showSlowDeckLoadingWarning = true;
      }
    }
  }, {
    key: "afterLoadDeck",
    value: function afterLoadDeck(userDeckId, opponentId, callback, resp) {
      if (callback !== undefined) {
        callback(resp);
      }
      clearTimeout(this.checkLoadTimeTimeout);
      this.showSlowDeckLoadingWarning = false;
      this.deckStore.setShowData(resp);
      this.createUserInputStores();
      this.userDeckStore.create({
        queryStrings: {
          user_deck_id: userDeckId,
          opponent_id: opponentId
        },
        data: {
          deckId: resp.id
        }
      }, this.afterCreateUserDeck.bind(this));
      this.getReviewCards();
      if (this.deck.deckType === 'review' && this.deck.reviewsFilterDue !== 'past-due') {
        var text = this.deck.reviewsFilterDue === 'retired' ? 'This deck features only retired reviews.' : 'This deck features only already caught up reviews.';
        this.setCardNotice({
          timeout: 10000,
          text: text,
          buttonText: 'Show Current Reviews',
          onClick: this.resetReviewsDeckFilter,
          background: '#FFF',
          color: '#333',
          border: "4px solid ".concat(_constants.Theme.green)
        });
      }
      this.createEvent('deck - open deck', {
        languageId: resp.languageId,
        deckId: resp.id,
        deckType: resp.deckType
      });
    }
  }, {
    key: "resetReviewsDeckFilter",
    value: function resetReviewsDeckFilter() {
      this.deckStore.update({
        ids: {
          deckId: this.deck.id
        },
        data: {
          reviewsFilterDue: 'past-due'
        }
      }, this.afterResetReviewsDeckFilter);
    }
  }, {
    key: "afterResetReviewsDeckFilter",
    value: function afterResetReviewsDeckFilter() {
      this.resetDeck();
      this.hideCardNotice();
    }
  }, {
    key: "afterCreateUserDeck",
    value: function afterCreateUserDeck(resp) {
      this.userDeckStore.setShowData(resp);
      this.initializeCardAnimation();
    }
  }, {
    key: "storyDeck",
    get: function get() {
      return this.hasDeck && this.deck.deckRulebook && ['story', 'conversations', 'questions', 'gif', 'exercise', 'default', 'story-comprehension-linear', 'story-comprehension-mixed', 'story-comprehension-question'].includes(this.deck.deckRulebook.slug);
    }
  }, {
    key: "vocabDeck",
    get: function get() {
      return this.hasDeck && this.deck.deckRulebook && this.deck.deckRulebook.slug === 'vocab';
    }
  }, {
    key: "correctCardsStatusCards",
    get: function get() {
      if (this.deck.genderDeck) {
        return this.userDeckGenderCards;
      }
      if (this.deck.pluralDeck) {
        return this.userDeckPluralCards;
      }
      if (this.deck.numberDeck) {
        return this.userDeckNumberCards;
      }
      if (this.deck.triviaDeck) {
        return this.userDeckTriviaCards;
      }
    }
  }, {
    key: "currentSentence",
    get: function get() {
      var _this$currentCard$sen;
      if (this.currentCard.triviaCard && (_this$currentCard$sen = this.currentCard.sentence) !== null && _this$currentCard$sen !== void 0 && _this$currentCard$sen.answer) {
        var _this$currentCard$sen2;
        return (_this$currentCard$sen2 = this.currentCard.sentence) === null || _this$currentCard$sen2 === void 0 ? void 0 : _this$currentCard$sen2.answer;
      }
      return this.currentCard.sentence;
    }
  }, {
    key: "currentCardRevealed",
    get: function get() {
      return this.isLastCard || this.currentCardState.revealed || this.comprehendCard && !this.user.listeningComprehensionMode;
    }
  }, {
    key: "showDeckGrammar",
    get: function get() {
      return this.hasDeck && this.hasUserDeck && !this.showAncillaryCard && (this.deck.hasCombinedGrammarDescription || this.deck.hasCombinedDescription);
    }
  }, {
    key: "previousCard",
    get: function get() {
      var _this8 = this;
      if (this.deck && this.deck.cards && !this.userDeck.currentUserCardIsFirstInDeck) {
        var card = this.deck.cards.find(function (item) {
          return item.position === _this8.userDeck.currentPosition - 1;
        });
        return card;
      }
    }
  }, {
    key: "deckLoaded",
    get: function get() {
      return !this.deckStore.outstandingRequests && (0, _utils.isPresent)(this.deck) && (0, _utils.isPresent)(this.userDeck) && this.authUserStore.hasShowData;
    }

    // XP
  }, {
    key: "adjustedDefaultXp",
    get: function get() {
      return this.reviewDeck ? _constants.Constants.XP_CARD_REVIEW : _constants.Constants.XP_CARD_DEFAULT;
    }
  }, {
    key: "onHideArrowBox",
    value: function onHideArrowBox() {
      this.arrowBoxIsHidden = true;
    }
  }, {
    key: "designateUiElementAsSeen",
    value: function designateUiElementAsSeen(uiElement) {
      if ((0, _utils.isPresent)(uiElement) && this.user && !this.user.wasUiElementSeen(uiElement)) {
        this.user.designateUiElementAsSeen(uiElement);
        this.authUserStore.update({
          data: {
            ui_elements_seen: this.user.uiElementsSeen
          }
        });
      }
    }
  }, {
    key: "onDeleteReview",
    value: function onDeleteReview() {
      _overlay_ui["default"].clearOverlays();
      var cardId = this.currentCard.id;
      this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard, {
        forceAdvancement: true
      });
      this.cardStore.destroy({
        ids: {
          cardId: cardId
        }
      });
    }
  }, {
    key: "onSnoozeReview",
    value: function onSnoozeReview() {
      _overlay_ui["default"].clearOverlays();
      this.cardStore.snooze({
        ids: {
          cardId: this.currentCard.id
        }
      });
      this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard);
    }

    // SUPPLEMENT
  }, {
    key: "supplementMaximized",
    get: function get() {
      if (this.currentCardState.showHelp || !this.showDeckSupplement || this.translateCard && !this.currentCardRevealed && !this.currentCardState.showHelp) {
        return false;
      }
      if (!this.showVideoPlayer) {
        return true;
      }
      return this.user.supplementMaximized;
    }
  }, {
    key: "showDeckSupplement",
    get: function get() {
      return this.hasSupplementMedia && !this.isLastCard && !this.interjectionCard && !this.currentCardState.showHelp && (this.currentCardRevealed || !this.translateCard) && (this.currentCard.showSupplement || this.reviewDeck);
    }
  }, {
    key: "hasSupplementMedia",
    get: function get() {
      return this.currentCard && (this.currentCard.hasSupplementImage || this.currentCard.hasSupplementVideoClip);
    }

    // CARD STATE
  }, {
    key: "interjectionCard",
    get: function get() {
      return this.currentCardSlug === 'interjection';
    }
  }, {
    key: "cardType",
    get: function get() {
      if (this.hasCurrentCard) {
        return this.currentCardSlug;
      }
    }
  }, {
    key: "userResponseCard",
    get: function get() {
      return this.describeCard || this.answerCard;
    }
  }, {
    key: "vocabWordTranslateCard",
    get: function get() {
      return this.currentCardSlug === 'vocab_word_translate';
    }
  }, {
    key: "vocabCardUsesAudio",
    get: function get() {
      return this.canRecordMedia && this.user.vocabCardAudio;
    }
  }, {
    key: "onToggleRecordAudio",
    value: function onToggleRecordAudio() {
      if (this.canRecordMedia) {
        var _this$mediaStores$thi;
        if ((_this$mediaStores$thi = this.mediaStores[this.currentCard.id]) !== null && _this$mediaStores$thi !== void 0 && _this$mediaStores$thi.isRecording) {
          this.reveal(this.currentCard, this.currentCardState);
        }
        this.userInputStores[this.currentCard.id].onToggleRecordAudio();
      }
    }
  }, {
    key: "vocabCard",
    get: function get() {
      return this.vocabWordTranslateCard || this.vocabWordComprehendCard || this.vocabSentenceTranslateCard || this.vocabSentenceComprehendCard;
    }
  }, {
    key: "showUserInput",
    get: function get() {
      return this.layout.showUserInput && this.canRecordMedia && this.hasUserDeck;
    }
  }, {
    key: "showNoUserInputBar",
    get: function get() {
      return !this.showUserInput && !this.vocabCard && !this.triviaCard && !this.genderCard && !this.isLastCard && !this.interjectionCard;
    }
  }, {
    key: "isSecondToLastCard",
    get: function get() {
      return this.deck.hasCards && this.userDeck.numActiveUserCards <= 3 && !this.showAncillaryCard;
    }
  }, {
    key: "isFirstCard",
    get: function get() {
      return this.deck.hasCards && this.userDeck.numActiveUserCards === this.deck.cards.length;
    }
  }, {
    key: "showDeckHeader",
    get: function get() {
      return this.hasDeck && this.hasUserDeck;
    }
  }, {
    key: "showLoadingIcon",
    get: function get() {
      return !this.hasDeck || !this.hasUserDeck || !this.showAncillaryCard && this.userIsLoaded && (!this.localDeck && this.deckStore.showLoadingIcon || this.deckStore.outstandingRequests);
    }
  }, {
    key: "showVideoPlayer",
    get: function get() {
      return this.videoPossible && (this.comprehendCard || this.interjectionCard || this.currentCardRevealed);
    }
  }, {
    key: "videoPossible",
    get: function get() {
      return this.deckLoaded && (0, _utils.isPresent)(this.currentCard) && this.currentCard.hasTargetVideoClip;
    }
  }, {
    key: "reveal",
    value: function reveal() {
      var card = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cardState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!card) {
        card = this.currentCard;
      }
      if (!cardState) {
        cardState = this.currentCardState;
      }
      if ((0, _utils.isPresent)(cardState)) {
        cardState.set('revealed', true);
      }
      if (card && (card.comprehendCard || card.vocabWordComprehendCard) && this.canRecordMedia && (0, _utils.isPresent)(this.mediaStore)) {
        setTimeout(this.mediaStore.play, 10);
        if ((0, _utils.isPresent)(cardState)) {
          cardState.set('audioHasAutoPlayed', true);
        }
      }
      this.arrowBoxIsHidden = false;
    }
  }, {
    key: "revealText",
    value: function revealText(card, cardState) {
      this.reveal(card, cardState);
      this.textRevealed = true;
    }

    // CARD BUTTONS
  }, {
    key: "currentCardSlug",
    get: function get() {
      return this.currentCard && this.currentCard.cardTypeSlug;
    }
  }, {
    key: "releaseTimeoutGotoNextCard",
    value: function releaseTimeoutGotoNextCard(card, cardState, userCard) {
      this.onSoftReset();
      this.advanceCard(card, cardState, userCard);
    }
  }, {
    key: "disableRecordButton",
    get: function get() {
      return !(0, _utils.isPresent)(this.userInputStore.messageInput) && (!this.mediaStore.hasRecording || this.mediaStore.isRecording);
    }

    // MEDIA
  }, {
    key: "pauseMedia",
    value: function pauseMedia() {
      if ((0, _utils.isPresent)(this.mediaStore)) {
        this.mediaStore.pause();
      }
      if (this.canRecordMedia && (0, _utils.isPresent)(this.mediaStore)) {
        this.mediaStore.stopRecording();
      }
    }
  }, {
    key: "resetDeck",
    value: function resetDeck() {
      var _this$currentCard;
      clearTimeout(this.checkLoadTimeTimeout);
      this.onNewDeck();
      this.overlayExpanded = null;
      if (this.deckState) {
        this.deckState.onReset();
      }
      if ((_this$currentCard = this.currentCard) !== null && _this$currentCard !== void 0 && _this$currentCard.cardState) {
        this.currentCard.cardState.onReset();
      }
      this.userDeckStore.onReset({
        ids: {
          userDeckId: this.userDeck.id
        }
      }, this.loadDeck.bind(this, {
        id: this.deck.id,
        callback: _lodash.noop
      }));
      this.deckStore.clearShowData();
      this.userDeckStore.clearShowData();
    }
  }, {
    key: "hideDeckArrowBox",
    get: function get() {
      return this.arrowBoxIsHidden || this.cardIsAnimating || this.showLoadingIcon || this.currentCardState.submittedToFeed || (0, _utils.isPresent)(this.userInputStore) && this.userInputStore.inputType === 'text' || (0, _utils.isPresent)(this.messageInput);
    }
  }, {
    key: "showOnboardingTip",
    get: function get() {
      return !this.hideDeckArrowBox && (0, _utils.isPresent)(this.deckArrowBox) && this.deckArrowBox.match('Onboarding');
    }
  }, {
    key: "mediaBlocked",
    get: function get() {
      return this.cardIsAnimating || (0, _utils.isPresent)(this.overlayExpanded) || this.showOnboardingTip;
    }

    // REVIEWS
  }, {
    key: "reviewDeck",
    get: function get() {
      return this.deck.deckType === 'review' || this.routeStore.pathname() && this.routeStore.pathname().match('reviews');
    }

    // MEDIA
  }, {
    key: "canRecordVideo",
    get: function get() {
      return this.userResponseCard && this.canRecordMedia;
    }
  }, {
    key: "deviceCanRecordMedia",
    get: function get() {
      return (this.layout.isNative || this.layout.mediaRecorderSupported) && !this.deviceDeniedAccess;
    }
  }, {
    key: "canRecordMedia",
    get: function get() {
      return this.userIsLoaded && !this.user.blockMediaAccess && this.deviceCanRecordMedia;
    }
  }, {
    key: "showAncillaryCard",
    get: function get() {
      return this.checkpointCard || this.deckSummaryCard;
    }
  }, {
    key: "isLastCard",
    get: function get() {
      return this.currentCard ? this.currentCard.isLastCard : null;
    }

    // FEED
  }, {
    key: "onRetireReview",
    value: function onRetireReview() {
      _overlay_ui["default"].clearOverlays();
      this.cardStore.retire({
        ids: {
          cardId: this.currentCard.id
        }
      }, _lodash.noop);
      this.advanceCard(this.currentCard, this.currentCardState, this.currentUserCard);
    }
  }, {
    key: "updateSpacedRepetitionFields",
    value: function updateSpacedRepetitionFields(card) {
      var data = {
        last_score: card.lastScore,
        views_count: card.viewsCount,
        easiness_factor: card.easinessFactor,
        repetition_interval: card.repetitionInterval,
        review_after: card.reviewAfter ? card.reviewAfter.toString : null,
        consecutive_good_scores: card.consecutiveGoodScores,
        had_positive_score: card.hadPositiveScore
      };
      if (!this.localUserDeck) {
        this.cardStore.update({
          data: data,
          ids: {
            cardId: card.id
          }
        }, _lodash.noop);
      }
    }
  }, {
    key: "onSubmitToFeed",
    value: function onSubmitToFeed() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var xp;
      if ((0, _utils.isPresent)(this.userInputStore) && this.userInputStore.messageInput) {
        xp = 3;
        this.onSubmitMessageToFeed();
      } else if ((0, _utils.isPresent)(this.mediaStore) && this.mediaStore.hasRecording) {
        if (this.mediaStore.mediaType === 'audio') {
          xp = 5;
        } else {
          xp = 7;
        }
        this.onSubmitMediaToFeed();
      }
      if ((0, _utils.isPresent)(this.userInputStore) && this.userInputStore.messageInput || (0, _utils.isPresent)(this.mediaStore) && this.mediaStore.hasRecording) {
        if (this.currentUserCard.xp === 0) {
          this.incrementXp(xp);
          this.userDeck.currentUserCard.set('xp', xp);
          this.createXpAnimation({
            type: 'deck',
            namespace: this.userDeck.id,
            id: (0, _utils.createUuid)(),
            xp: xp,
            xpXPos: params.xpXPos
          });
        }
      }
    }
  }, {
    key: "onSubmitMediaToFeed",
    value: function onSubmitMediaToFeed() {
      if (!this.layout.isNative) {
        this.currentCardState.submittingToFeed = true;
        this.feedEntryStore.multipartCreate({
          data: this.mediaStore && this.mediaStore.getFormData(),
          queryStrings: {
            duration: this.mediaStore && this.mediaStore.duration,
            concept_id: this.deck.conceptId,
            deck_id: this.deck.id,
            card_rule_id: this.currentCard.cardRuleId
          }
        }, this.afterCreateFeedEntry.bind(this));
      }
    }
  }, {
    key: "onSubmitMessageToFeed",
    value: function onSubmitMessageToFeed() {
      this.currentCardState.submittingToFeed = true;
      this.feedEntryStore.create({
        data: {
          message: (0, _utils.isPresent)(this.userInputStore) && this.userInputStore.messageInput,
          concept_id: this.deck.conceptId,
          deck_id: this.deck.id,
          card_rule_id: this.currentCard.cardRuleId
        }
      }, this.afterCreateFeedEntry.bind(this));
    }
  }, {
    key: "afterCreateFeedEntry",
    value: function afterCreateFeedEntry(resp) {
      if ((0, _utils.isPresent)(this.userInputStore)) {
        this.userInputStore.setInputType(null);
      }
      if ((0, _utils.isPresent)(this.currentCardState)) {
        this.currentCardState.submittingToFeed = false;
        this.currentCardState.submittedToFeed = true;
      }
      this.lastFeedEntryId = resp.id;
    }

    // CARD NOTICE
  }, {
    key: "setCardNotice",
    value: function setCardNotice(params) {
      clearTimeout(this._timeout);
      this.cardNotice = params;
      if (params.timeout) {
        this._timeout = setTimeout(this.hideCardNotice.bind(this), params.timeout);
      }
    }
  }, {
    key: "hideCardNotice",
    value: function hideCardNotice() {
      clearTimeout(this._timeout);
      this.cardNotice = null;
    }

    // ACTIONS
  }, {
    key: "createXpAnimation",
    value: function createXpAnimation(params) {
      if (!this.user.showCoinAnimation) {
        params.hideCoinAnimation = true;
      }
      if (params.xp > 0 && params.triviaCard) {
        this.soundEffectStore.play('correctChime');
      } else if (params.xp > 0) {
        this.soundEffectStore.play('correct');
      } else {
        this.soundEffectStore.play('failure');
      }
      this.xpState.createXpAnimation(params);
    }
  }, {
    key: "onWordClick",
    value: function onWordClick() {
      this.wordClickCount += 1;
    }
  }, {
    key: "onSoftReset",
    value: function onSoftReset() {
      if (this.triviaCard) {
        this.currentUserCard.set('seen', false);
      }
      this.overlayExpanded = null;
      this.onReset();
    }
  }, {
    key: "createUserInputStores",
    value: function createUserInputStores() {
      var _this9 = this;
      this.mediaStores = {};
      this.userInputStores = {};
      (0, _lodash.each)(this.deck.cards, function (card) {
        _this9.mediaStores[card.id] = new _stores.MediaStore({
          isNative: _this9.layout.isNative,
          parent: _this9,
          cardId: card.id
        });
        _this9.userInputStores[card.id] = new _stores.UserInputStore(_this9.mediaStores[card.id]);
      });
    }
  }, {
    key: "onCloseDeck",
    value: function onCloseDeck() {
      clearTimeout(this.checkLoadTimeTimeout);
      if ((0, _utils.isPresent)(this.currentCardState)) {
        this.currentCardState.onReset();
      }
      if ((0, _utils.isPresent)(this.mediaStore)) {
        if (this.mediaStore.isRecording) {
          this.mediaStore.stopRecording();
        }
        if (this.mediaStore.playing) {
          this.mediaStore.pause();
        }
      }
      this.userDeckStore.clearShowData();
      this.conceptWordStore.clearIndexData();
      this.onReset();
      _exercise_ui["default"].reset();
      this.animationCards = [];
      this.cardIsAnimating = false;
      this.firstCardHasAdvanced = false;
    }
  }, {
    key: "onResetUserInputStore",
    value: function onResetUserInputStore() {
      if ((0, _utils.isPresent)(this.userInputStore)) {
        this.userInputStore.onMediaReset();
      }
    }
  }, {
    key: "onReset",
    value: function onReset() {
      this.arrowBoxIsHidden = false;
      this.textRevealed = false;
      this.showCloseModal = false;
      this.seenConceptDescription = false;
      this.lastFeedEntryId = null;
      this.warning = '';
      this.reviewModalWord = {};
      this.reviewModalConcept = {};
      if ((0, _utils.isPresent)(this.userInputStore)) {
        this.userInputStore.reset();
      }
      this.vocabStuckClicked = false;
      this.sound = null;
      if ((0, _utils.isPresent)(this.currentCardState) && this.currentCardState.onReset) {
        this.currentCardState.onReset();
      }
    }
  }, {
    key: "setWord",
    value: function setWord(word) {
      this.wordStore.setShowData(word);
      if (word.hasDictionaryConcept || word.hasRelatedWords) {
        this.wordStore.getShow({
          ids: {
            wordId: word.id
          }
        });
      }
    }
  }, {
    key: "gotoVocabCard",
    value: function gotoVocabCard(card) {
      if ((0, _utils.isBlank)(card.word)) {
        return;
      }
      this.designateUiElementAsSeen('vocabCardOnboarding');
      this.overlayExpanded = null;
      this.setWord(card.word);
      _overlay_ui["default"].addOverlay('vocabCard', {
        card: card
      });
    }
  }, {
    key: "gotoWordVocabCard",
    value: function gotoWordVocabCard(word) {
      _overlay_ui["default"].addOverlay('vocabCard', {
        word: word
      });
    }
  }, {
    key: "gotoTriviaResults",
    value: function gotoTriviaResults(card) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('triviaResults', {
        card: card
      });
    }
  }, {
    key: "gotoShortcuts",
    value: function gotoShortcuts() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('shortcuts');
    }
  }, {
    key: "gotoCardComments",
    value: function gotoCardComments(card) {
      this.designateUiElementAsSeen('commentOnboarding');
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('cardComments', {
        card: card
      });
      this.createEvent('deck - view comments', {
        languageId: this.deck.languageId,
        deckId: this.deck.id,
        cardId: card.id
      });
    }
  }, {
    key: "gotoGrammarTip",
    value: function gotoGrammarTip(card) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('grammarTip', {
        card: card
      });
      this.createEvent('deck - open grammar tip', {
        languageId: this.deck.languageId,
        deckId: this.deck.id,
        cardId: card.id
      });
    }
  }, {
    key: "gotoCardNote",
    value: function gotoCardNote(card) {
      this.designateUiElementAsSeen('noteOnboarding');
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('cardNote', {
        card: card
      });
    }
  }, {
    key: "gotoReviewDetails",
    value: function gotoReviewDetails(card) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('reviewDetails', {
        card: card
      });
    }
  }, {
    key: "gotoConjugationTable",
    value: function gotoConjugationTable(word) {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('conjugationTable', {
        word: word
      });
    }
  }, {
    key: "gotoDeckSettings",
    value: function gotoDeckSettings() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('deckSettings');
    }
  }, {
    key: "gotoReportBug",
    value: function gotoReportBug() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('reportBug');
    }
  }, {
    key: "gotoDeckGrammar",
    value: function gotoDeckGrammar() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('deckGrammar');
    }
  }, {
    key: "closeDeckGrammar",
    value: function closeDeckGrammar() {
      _overlay_ui["default"].removeOverlay('deckGrammar');
    }
  }, {
    key: "gotoTenseDescription",
    value: function gotoTenseDescription() {
      this.overlayExpanded = null;
      _overlay_ui["default"].addOverlay('tenseDescription');
    }
  }, {
    key: "gotoMediaBlocked",
    value: function gotoMediaBlocked() {
      _overlay_ui["default"].addOverlay('mediaBlocked');
    }
  }, {
    key: "skipToEnd",
    value: function skipToEnd() {
      var _this10 = this;
      if ((0, _utils.isBlank)(this.userDeck)) {
        return;
      }
      (0, _lodash.each)(this.userDeck.userCards.filter(function (item) {
        return item.cardId !== _this10.deck.lastCard.id;
      }), function (userCard) {
        userCard.seen = true;
        userCard.skipped = true;
        userCard.active = false;
      });
      var card = this.deck.cards.find(function (item) {
        return item.cardType && item.cardType.slug === 'deck_summary';
      });
      var userCard = this.userDeck.userCards.find(function (item) {
        return item.cardId === card.id;
      });
      this.animationCards = [{
        id: (0, _utils.createUuid)(),
        card: card,
        userCard: userCard,
        cardState: card.cardState,
        position: 0,
        advanceCard: false,
        animateCard: false
      }, {
        id: (0, _utils.createUuid)(),
        card: this.deck.lastCard,
        userCard: this.userDeck.lastUserCard,
        cardState: this.deck.lastCard.cardState,
        position: 1,
        advanceCard: false,
        animateCard: false
      }];
      this.gotoCard(card.id);
    }
  }, {
    key: "gotoCard",
    value: function gotoCard(id) {
      this.onReset();
      this.userDeck.gotoCard(id);
      this.userDeckStore.update({
        ids: {
          userDeckId: this.userDeck.id
        },
        data: {
          current_card_id: id
        }
      }, _lodash.noop);
    }
  }, {
    key: "showExerciseAnswer",
    value: function showExerciseAnswer(card, cardState, userCard) {
      var _this11 = this;
      this.reveal(card, cardState);
      _exercise_ui["default"].revealExerciseAnswers({
        skipAudio: true,
        correctCallback: function correctCallback() {
          return _this11.onCorrectAnswer(card, cardState, userCard, {
            xp: 1,
            xpSlug: 'exercise'
          });
        },
        incorrectCallback: function incorrectCallback() {
          return _this11.onIncorrectAnswer(card, cardState, userCard);
        }
      });
    }
  }, {
    key: "onCorrectAnswer",
    value: function onCorrectAnswer(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this.blurInputFocus();
      var xp = params.xp || 2;
      if (xp && !params.xpSlug) {
        params.xpSlug = 'exercise';
      }
      var score = params.score || 2;
      var points = params.points || 0;
      var firstAnswerCorrect = !userCard.seen;
      userCard.set('correct', true);
      userCard.set('firstAnswerCorrect', firstAnswerCorrect);
      if (!this.reviewDeck) {
        userCard.set('score', score);
        userCard.set('active', false);
        if (userCard.xp === 0) {
          this.incrementXp(xp);
          userCard.set('xp', xp);
        }
        userCard.set('currentCorrect', true);
        if (!this.localUserDeck) {
          this.userCardStore.update({
            ids: {
              userCardId: userCard.id
            },
            data: {
              score: score,
              active: false,
              points: points,
              correct: true,
              first_answer_correct: firstAnswerCorrect,
              points_submitted: true,
              seconds_elapsed: params.secondsElapsed,
              xp: xp,
              multiple_choice_option_id: params.multipleChoiceOptionId,
              xp_slug: params.xpSlug
            }
          }, _lodash.noop);
        }
        this.createXpAnimation({
          xp: xp,
          id: (0, _utils.createUuid)(),
          triviaCard: card.triviaCard,
          namespace: this.userDeck.id,
          xpXPos: 200
        });
      }
    }
  }, {
    key: "onIncorrectAnswer",
    value: function onIncorrectAnswer(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      this.blurInputFocus();
      userCard.set('currentIncorrect', true);
      if (!this.reviewDeck) {
        userCard.set('score', 0);
        userCard.set('points', 0);
        userCard.set('pointsSubmitted', true);
        if (!this.localUserDeck) {
          this.userCardStore.update({
            ids: {
              userCardId: userCard.id
            },
            data: {
              score: 0,
              points: 0,
              correct: false,
              points_submitted: true,
              multiple_choice_option_id: params.multipleChoiceOptionId,
              seconds_elapsed: params.secondsElapsed
            }
          }, _lodash.noop);
        }
        this.createXpAnimation({
          xp: 0,
          id: (0, _utils.createUuid)(),
          triviaCard: card.triviaCard,
          namespace: this.userDeck.id,
          xpXPos: 200
        });
      }
    }
  }, {
    key: "blurInputFocus",
    value: function blurInputFocus() {
      if (!this.layout.isNative) {
        (0, _lodash.each)(document.getElementsByTagName('input'), function (el) {
          el.blur();
        });
      }
    }
  }, {
    key: "incrementXp",
    value: function incrementXp(xp) {
      if (xp && xp > 0) {
        var beforeUpdateXp = this.user.currentDayXp;
        var beforeUpdateLevel = this.targetLanguage.xpLevel;
        this.user.incrementXp(xp);
        this.targetLanguage.incrementXp(xp);
        var afterUpdateLevel = this.targetLanguage.xpLevel;
        var streakMet = beforeUpdateXp < this.user.dailyXpGoal && this.user.currentDayXp >= this.user.dailyXpGoal;
        if (streakMet) {
          this.user.set('currentStreakCount', this.user.currentStreakCount + 1);
          this.setCardNotice({
            timeout: 7500,
            text: "".concat(this.user.currentStreakCount, " Day Streak!"),
            background: '#FFF',
            color: '#333',
            border: "4px solid ".concat(_constants.Theme.green),
            icon: 'streak',
            chime: true
          });
        } else if ((0, _utils.isPresent)(this.deck.xpBreakdownToday)) {
          this.deck.xpBreakdownToday.set('count', this.deck.xpBreakdownToday.count + 1);
          if (this.reviewDeck && this.deck.useDailyGoal && this.deck.reviewedToday === this.deck.dailyGoal) {
            this.setCardNotice({
              timeout: 7500,
              text: 'Daily Goal Reached for this Deck!',
              background: '#FFF',
              color: '#333',
              border: "4px solid ".concat(_constants.Theme.green),
              icon: 'celebration',
              chime: true
            });
          }
        }
        var streakExtendGoalMet = beforeUpdateXp < this.user.streakExtendGoal && this.user.currentDayXp >= this.user.streakExtendGoal;
        var streakExtendNoticeGoal = Math.floor(this.user.streakExtendGoal * 0.75);
        if (streakExtendGoalMet && this.user.streakExtensionIsAllowed) {
          this.setCardNotice({
            timeout: 10000,
            text: "Congrats on reaching ".concat(this.user.streakExtendGoal, "XP!"),
            subText: 'To reward you, we\'ve extended your streak.',
            background: '#FFF',
            color: '#333',
            border: "4px solid ".concat(_constants.Theme.green),
            icon: 'streak',
            chime: true
          });
        } else if (beforeUpdateXp < streakExtendNoticeGoal && this.user.currentDayXp >= streakExtendNoticeGoal && this.user.streakExtensionIsAllowed) {
          this.setCardNotice({
            timeout: 15000,
            text: "You\u2019ve reached ".concat(streakExtendNoticeGoal, "XP, well done!"),
            subText: "Did you know that at ".concat(this.user.streakExtendGoal, "XP we will reward you with a streak extension?"),
            background: '#FFF',
            color: '#333'
          });
        }
        if (beforeUpdateLevel !== afterUpdateLevel) {
          this.setCardNotice({
            timeout: 7500,
            text: "You are now Level ".concat(this.targetLanguage.xpLevel, "!"),
            background: '#FFF',
            color: '#333',
            border: "4px solid ".concat(_constants.Theme.green),
            icon: 'celebration',
            chime: true
          });
        }
      }
    }
  }, {
    key: "advanceCard",
    value: function advanceCard(card, cardState, userCard) {
      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var allowAdvancement = params.forceAdvancement || params.score === _constants.Constants.GOOD_SCORE || params.score === _constants.Constants.EASY_SCORE || !this.blockLastLearningCardAdvancement;
      this.hideCardNotice();
      if ((0, _utils.isPresent)(this.mediaStores[card.id])) {
        this.mediaStores[card.id].pause();
        this.mediaStores[card.id].onSoftReset();
      }
      if (allowAdvancement) {
        var xpSlug;
        var score = params.score;
        if ((0, _utils.isPresent)(params.xp) && userCard.xp === 0 && (!card.exerciseCard || this.reviewDeck)) {
          this.createXpAnimation({
            type: 'deck',
            namespace: this.userDeck.id,
            id: (0, _utils.createUuid)(),
            xp: params.xp,
            xpXPos: params.xpXPos
          });
          xpSlug = this.getXpSlug(params);
        }
        if (!score && !this.reviewDeck && (card.cardRule.cycleCardsUntilCorrect || card.triviaCard)) {
          score = userCard.correct ? _constants.Constants.EASY_SCORE : _constants.Constants.BAD_SCORE;
        }
        cardState.submittedToFeed = false;
        this.wordClickCount = 0;
        this.cardSeenCount += 1;
        if ((0, _utils.isPresent)(params.xp)) {
          this.incrementXp(params.xp);
        }
        var data = {
          xp: params.xp,
          xp_slug: params.overrideXpSlug || xpSlug
        };
        if ((0, _utils.isPresent)(score)) {
          data.score = score;
          userCard.set('score', score);
          if (this.reviewDeck) {
            if (score !== _constants.Constants.BAD_SCORE && card.reviewAfter && card.reviewAfter.dateObj && card.reviewAfter.dateObj < new Date()) {
              this.user.set('pastDueReviewCardsCount', this.user.pastDueReviewCardsCount - 1);
            }
            card.processScore(score);
            this.updateSpacedRepetitionFields(card);
          }
        }
        if (!this.localUserDeck) {
          this.userCardStore.update({
            ids: {
              userCardId: userCard.id
            },
            data: data
          }, _lodash.noop);
        }
        var active = 'active' in params ? params.active : [_constants.Constants.BAD_SCORE, 0].includes(score) && (card.cardRule.cycleCardsUntilCorrect || this.reviewDeck);
        userCard.set('localUpdatedAt', +new Date());
        userCard.set('active', active);
        userCard.set('skipped', false);
        if (userCard.xp === 0) {
          userCard.set('xp', params.xp);
        }
        userCard.set('seen', true);
        if (this.userDeck && this.userDeck.setProgressCurrent) {
          this.userDeck.setProgressCurrent(this.userDeck.progressCurrent + 1);
        }
        this.setCurrentCard();
        this.addNextCardToAnimationQueue();
        if (this.isSecondToLastCard) {
          this.animationQueue.push({
            name: 'deckCompleted',
            deckId: this.deck.id
          });
        }
      } else {
        this.onResetUserInputStore();
        if (this.reviewDeck && params.score === _constants.Constants.BAD_SCORE) {
          userCard.set('score', params.score);
          card.processScore(params.score);
          this.updateSpacedRepetitionFields(card);
        }
      }
      this.onReset();
      if (this.exercise) {
        this.exercise.state.reset();
      }
    }
  }, {
    key: "exercise",
    get: function get() {
      if ((0, _utils.isBlank)(this.currentCard)) {
        return;
      }
      return _exercise_ui["default"].exercises[this.currentCard.id];
    }
  }, {
    key: "getXpSlug",
    value: function getXpSlug(params) {
      var xpSlug;
      if (this.reviewDeck) {
        xpSlug = 'card-review-deck';
      } else if (params.score === 0) {
        xpSlug = 'card-add-to-review';
      } else {
        xpSlug = 'card';
      }
      return xpSlug;
    }
  }, {
    key: "blockLastLearningCardAdvancement",
    get: function get() {
      if ((0, _utils.isBlank)(this.currentCard)) {
        return;
      }
      var remainingCards = this.reviewDeck ? this.userDeck.numberActiveLearningCards : this.userDeck.numberActiveLearningCardsWithCardType;
      return this.currentCard.cardRule.cycleCardsUntilCorrect && this.currentUserCard.active && remainingCards === 1;
    }
  }, {
    key: "nextCurrentCard",
    get: function get() {
      var _this12 = this;
      return this.nextCurrentCardId && this.hasDeck && this.deck.cards && this.deck.cards.find(function (item) {
        return item.id === _this12.nextCurrentCardId;
      });
    }
  }, {
    key: "nextCurrentCardId",
    get: function get() {
      if (!this.userDeck) {
        return;
      }
      return this.reviewDeck ? this.userDeck.cardIdForNextActiveUserCardWithWrapping : this.userDeck.cardIdForNextActiveUserCardWithWrappingByCardType;
    }
  }, {
    key: "gotoPreviousCard",
    value: function gotoPreviousCard() {
      var _this13 = this;
      if (!this.isFirstCard && (0, _utils.isPresent)(this.userDeck)) {
        this.onReset();
        this.overlayExpanded = null;
        if (!this.userDeck.currentUserCardIsFirstInDeck && this.userDeck.previousUserCard) {
          var nextCurrentCard = this.currentCard;
          var nextUserCard = this.currentUserCard;
          _stores.UserDeckStore.update({
            ids: {
              userDeckId: this.userDeck.id
            },
            data: {
              current_card_id: this.userDeck.previousUserCard.cardId
            }
          }, _lodash.noop);
          this.userDeck.previousUserCard.set('active', true);
          this.userCardStore.update({
            ids: {
              userCardId: this.userDeck.previousUserCard.id
            },
            data: {
              active: true
            }
          }, _lodash.noop);
          this.userDeck.set('progressCurrent', this.userDeck.progressCurrent - 1);
          this.userDeck.set('currentCardId', this.userDeck.previousUserCard.cardId);
          var currentCard = this.deck.cards.find(function (item) {
            return item.id === _this13.userDeck.currentCardId;
          });
          var userCard = this.userDeck.userCards.find(function (item) {
            return item.cardId === currentCard.id;
          });
          this.animationCards = [{
            id: (0, _utils.createUuid)(),
            card: currentCard,
            userCard: userCard,
            cardState: currentCard.cardState,
            position: 0,
            advanceCard: false,
            animateCard: false
          }, {
            id: (0, _utils.createUuid)(),
            card: nextCurrentCard,
            userCard: nextUserCard,
            cardState: nextCurrentCard.cardState,
            position: 1,
            advanceCard: false,
            animateCard: false
          }];
        }
        this.onReset();
      }
    }
  }, {
    key: "setCurrentCard",
    value: function setCurrentCard() {
      if (this.nextCurrentCardId && !this.blockLastLearningCardAdvancement) {
        _stores.UserDeckStore.update({
          ids: {
            userDeckId: this.userDeck.id
          },
          data: {
            current_card_id: this.nextCurrentCardId
          }
        }, _lodash.noop);
        this.userDeck.set('currentCardId', this.nextCurrentCardId);
        if (!this.currentUserCard.active) {
          this.currentUserCard.set('active', true);
        }
      }
      this.onReset();
      if (this.currentCard) {
        if (_exercise_ui["default"].exercises[this.currentCard.id]) {
          _exercise_ui["default"].exercises[this.currentCard.id].state.reset();
        }
        if ((0, _utils.isPresent)(this.currentCardState) && this.currentCardState.onReset) {
          this.currentCardState.onReset();
        }
      }
    }
  }, {
    key: "removeFromAnimationQueue",
    value: function removeFromAnimationQueue(key, value) {
      this.animationQueue = this.animationQueue.filter(function (item) {
        return item[key] != value;
      });
    }
  }, {
    key: "onNewDeck",
    value: function onNewDeck() {
      this.vocabStuckClicked = false;
      this.cardSeenCount = 0;
      this.skipCardAnimation = false;
      this.cardIsAnimating = false;
      this.firstCardHasAdvanced = false;
      this.animationCards = [];
    }
  }, {
    key: "closeFeedInfo",
    value: function closeFeedInfo() {
      this.currentCardState.closeFeedEntry();
    }
  }, {
    key: "initializeCardAnimation",
    value: function initializeCardAnimation() {
      this.addCardToAnimationQueue(this.currentCard, this.currentUserCard);
      this.addNextCardToAnimationQueue();
    }
  }, {
    key: "addNextCardToAnimationQueue",
    value: function addNextCardToAnimationQueue() {
      var _this14 = this;
      this.setCardIsAnimating(true);
      if (this.nextCurrentCardId && this.currentCard && this.currentCard.id !== this.nextCurrentCardId) {
        var nextUserCard = this.userDeck.userCards.find(function (item) {
          return item.cardId === _this14.nextCurrentCardId;
        });
        this.addCardToAnimationQueue(this.nextCurrentCard, nextUserCard);
      }
      this.advanceCards();
    }
  }, {
    key: "addCardToAnimationQueue",
    value: function addCardToAnimationQueue(card, userCard) {
      var _card$cardState;
      if ((0, _utils.isBlank)(card)) {
        return;
      }
      var position = (0, _utils.isBlank)(this.animationCards) ? 1 : (0, _lodash.last)(this.animationCards).position + 1;
      card === null || card === void 0 || (_card$cardState = card.cardState) === null || _card$cardState === void 0 || _card$cardState.resetWithinCard();
      this.animationCards.push({
        id: (0, _utils.createUuid)(),
        card: card,
        userCard: userCard,
        cardState: card.cardState,
        position: position,
        animateCard: false
      });
    }
  }, {
    key: "decrementCardAnimationPositions",
    value: function decrementCardAnimationPositions() {
      (0, _lodash.each)(this.animationCards, function (card) {
        card.position -= 1;
      });
    }
  }, {
    key: "showCardAnimation",
    get: function get() {
      return this.user.showCardAnimation && !this.skipCardAnimation;
    }
  }, {
    key: "advanceCards",
    value: function advanceCards() {
      var _this15 = this;
      if (this.showCardAnimation) {
        setTimeout(function () {
          return _this15.startCardAnimation();
        }, _constants.Constants.DELAY_BEFORE_INITIATING_CARD_ANIMATION);
      } else {
        this.decrementCardAnimationPositions();
        this.afterCardAdvancement();
        this.set('firstCardHasAdvanced', true);
        this.setCardIsAnimating(false);
      }
      this.setSkipCardAnimation(false);
    }
  }, {
    key: "startCardAnimation",
    value: function startCardAnimation() {
      var _this16 = this;
      this.setCardIsAnimating(true);
      (0, _lodash.each)(this.animationCards, function (card) {
        card.animateCard = true;
      });
      setTimeout(function () {
        return _this16.removeCardAnimation();
      }, _constants.Constants.DELAY_BEFORE_REMOVING_CARD_AFTER_ANIMATION);
    }
  }, {
    key: "removeCardAnimation",
    value: function removeCardAnimation() {
      var _this17 = this;
      (0, _lodash.each)(this.animationCards, function (card) {
        card.animateCard = false;
        card.position -= 1;
      });
      this.setCardIsAnimating(false);
      if (this.layout.isNative) {
        setTimeout(function () {
          return _this17.afterCardAdvancement();
        }, 500);
      } else {
        this.afterCardAdvancement();
      }
    }
  }, {
    key: "afterCardAdvancement",
    value: function afterCardAdvancement() {
      var _this18 = this;
      // Clean up resources for cards moving off-screen
      var cardsToRemove = this.animationCards.filter(function (item) {
        return item.position === -1;
      });
      cardsToRemove.forEach(function (animationCard) {
        var cardId = animationCard.card.id;
        var mediaStore = _this18.mediaStores[cardId];
        if (mediaStore && mediaStore.cleanupOffscreen) {
          mediaStore.cleanupOffscreen();
        }
      });
      this.animationCards = this.animationCards.filter(function (item) {
        return item.position !== -1;
      });
    }
  }, {
    key: "enrichWord",
    value: function enrichWord(card) {
      var forceEnrichment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!forceEnrichment && card.isEnriched || (0, _utils.isBlank)(card.word)) {
        return;
      }
      if (!forceEnrichment && this.enrichedTranslations[card.word.id]) {
        card.setWord(this.enrichedTranslations[card.word.id]);
      } else {
        this.wordStore.getShow({
          ids: {
            wordId: card.word.id
          }
        }, this.afterGetEnrichedWord.bind(this, card));
      }
    }
  }, {
    key: "enrichSentence",
    value: function enrichSentence(card) {
      var _card$cardType2;
      var forceEnrichment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.user.showEnrichedSentences && ((_card$cardType2 = card.cardType) === null || _card$cardType2 === void 0 ? void 0 : _card$cardType2.id) !== 'bfde0cda-d6fe-4524-965f-173eb841aa9e' || !forceEnrichment && card.isEnriched || (0, _utils.isBlank)(card.sentence)) {
        return;
      }
      if (!forceEnrichment && this.enrichedTranslations[card.sentence.id]) {
        card.setSentence(this.enrichedTranslations[card.sentence.id]);
      } else {
        this.sentenceStore.getShow({
          ids: {
            sentenceId: card.sentence.id
          }
        }, this.afterGetEnrichedSentence.bind(this, card));
      }
    }
  }, {
    key: "afterGetEnrichedWord",
    value: function afterGetEnrichedWord(card, resp) {
      var word = (0, _serializr.deserialize)(_models.Word, resp);
      card.setWord(word);
      this.enrichedTranslations[resp.id] = word;
    }
  }, {
    key: "afterGetEnrichedSentence",
    value: function afterGetEnrichedSentence(card, resp) {
      var sentence = (0, _serializr.deserialize)(_models.Sentence, resp);
      card.setSentence(sentence);
      this.enrichedTranslations[resp.id] = sentence;
    }
  }]);
}(_root_state["default"]), _descriptor = _applyDecoratedDescriptor(_class.prototype, "cardSeenCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "wordClickCount", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "seenConceptDescription", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "selectedConceptDescriptionOpen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "cardNotice", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "showCloseModal", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "animationQueue", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "lastFeedEntryId", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "dataSaverModalSeen", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "enrichedTranslations", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "overlayExpanded", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "sound", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "textRevealed", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "arrowBoxIsHidden", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "cardIsAnimating", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "firstCardHasAdvanced", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "mediaStores", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "userInputStores", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "shortcutsAssigned", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "animationCards", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "deviceDeniedAccess", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "showSlowDeckLoadingWarning", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "localDeck", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "localUserDeck", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "hideCardIcons", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "warning", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "showCorrectAnswer", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "reviewCards", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "user", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "treeNodeId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "treeNodeId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentUserCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentUserCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCardState", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCardState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "siteIsDefault", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "siteIsDefault"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "site", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "site"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguageId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguageId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "targetLanguage", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "targetLanguage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "routeToOnClose", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "routeToOnClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userInputStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userInputStore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mediaStore", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mediaStore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearAudioStreams", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearAudioStreams"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "commentDebugInfo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "commentDebugInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "debugInfo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "debugInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordSentences", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordSentences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userIsLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userIsLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasUserDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasUserDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCurrentCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasCurrentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCorrectCardStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCorrectCardStatus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "levelIncremented", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "levelIncremented"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCardIsAnimating", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCardIsAnimating"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSkipCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSkipCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "assignShortcut", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "assignShortcut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeShortcut", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeShortcut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isShortcutAssigned", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "isShortcutAssigned"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skipAnimationGotoLastCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "skipAnimationGotoLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skipAnimationNextCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "skipAnimationNextCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSectionHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSectionHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numVocabSections", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numVocabSections"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabTextHeight", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabTextHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getReviewCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getReviewCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetReviewCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetReviewCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "reviewCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createEvent", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addCardToReviewCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "addCardToReviewCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeCardFromReviewCards", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "removeCardFromReviewCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCreateReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterCreateReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "normalizeString", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "normalizeString"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getEvaluateTextInputMatch", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "getEvaluateTextInputMatch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "textEntryMatchesSynonym", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "textEntryMatchesSynonym"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onEvaluateTextInput", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onEvaluateTextInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWordInputChange", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onWordInputChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWordInputChangeAndEvaluate", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onWordInputChangeAndEvaluate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkpointCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkpointCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "wordOptionsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "wordOptionsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckSummaryCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckSummaryCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "genderResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "genderResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "conjugationResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "conjugationResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluralCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluralCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pluralResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "pluralResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "numberResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "numberResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaIntroCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaIntroCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "triviaResultsCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "triviaResultsCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "describeCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "describeCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answerCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "answerCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "comprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "comprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "translateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "translateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exerciseCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exerciseCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabWordComprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabWordComprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceTranslateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceTranslateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceComprehendCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceComprehendCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabSentenceTranslateAudioCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabSentenceTranslateAudioCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckGenderCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckGenderCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckPluralCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckPluralCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckNumberCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckNumberCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userDeckTriviaCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userDeckTriviaCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deviceType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deviceType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkDeckLoadTime", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "checkDeckLoadTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterLoadDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterLoadDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetReviewsDeckFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "resetReviewsDeckFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterResetReviewsDeckFilter", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "afterResetReviewsDeckFilter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCreateUserDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterCreateUserDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "storyDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "storyDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "correctCardsStatusCards", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "correctCardsStatusCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentSentence", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCardRevealed", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCardRevealed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeckGrammar", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDeckGrammar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deckLoaded", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deckLoaded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adjustedDefaultXp", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "adjustedDefaultXp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onHideArrowBox", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onHideArrowBox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "designateUiElementAsSeen", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "designateUiElementAsSeen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDeleteReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDeleteReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSnoozeReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSnoozeReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "supplementMaximized", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "supplementMaximized"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeckSupplement", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDeckSupplement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSupplementMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hasSupplementMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "interjectionCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "interjectionCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "cardType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "userResponseCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "userResponseCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabWordTranslateCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabWordTranslateCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabCardUsesAudio", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabCardUsesAudio"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onToggleRecordAudio", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "onToggleRecordAudio"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "vocabCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "vocabCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showUserInput", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showUserInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNoUserInputBar", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNoUserInputBar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isSecondToLastCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isSecondToLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFirstCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFirstCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDeckHeader", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showDeckHeader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showLoadingIcon", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showLoadingIcon"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showVideoPlayer", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showVideoPlayer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "videoPossible", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "videoPossible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reveal", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "reveal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "revealText", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "revealText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentCardSlug", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentCardSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableRecordButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableRecordButton"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "pauseMedia", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "pauseMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "resetDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDeckArrowBox", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideDeckArrowBox"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showOnboardingTip", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showOnboardingTip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "mediaBlocked", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mediaBlocked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "reviewDeck", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "reviewDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canRecordVideo", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canRecordVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deviceCanRecordMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "deviceCanRecordMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canRecordMedia", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canRecordMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showAncillaryCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showAncillaryCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLastCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isLastCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRetireReview", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRetireReview"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateSpacedRepetitionFields", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateSpacedRepetitionFields"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmitToFeed", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmitToFeed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createXpAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createXpAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onWordClick", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onWordClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSoftReset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onSoftReset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createUserInputStores", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "createUserInputStores"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCloseDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onCloseDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onResetUserInputStore", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onResetUserInputStore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onReset", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onReset"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setWord", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class.prototype, "setWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoVocabCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoVocabCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoWordVocabCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoWordVocabCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoTriviaResults", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoTriviaResults"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoShortcuts", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoShortcuts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCardComments", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCardComments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoGrammarTip", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoGrammarTip"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCardNote", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCardNote"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoReviewDetails", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoReviewDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoConjugationTable", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoConjugationTable"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoDeckSettings", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoDeckSettings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoReportBug", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoReportBug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoDeckGrammar", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoDeckGrammar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDeckGrammar", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDeckGrammar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoTenseDescription", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoTenseDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeDeckGrammar", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeDeckGrammar"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoMediaBlocked", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoMediaBlocked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "skipToEnd", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "skipToEnd"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showExerciseAnswer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "showExerciseAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onCorrectAnswer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onCorrectAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onIncorrectAnswer", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onIncorrectAnswer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "blurInputFocus", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "blurInputFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incrementXp", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementXp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advanceCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "advanceCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exercise", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "exercise"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getXpSlug", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getXpSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "blockLastLearningCardAdvancement", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "blockLastLearningCardAdvancement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextCurrentCard", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextCurrentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextCurrentCardId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextCurrentCardId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "gotoPreviousCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "gotoPreviousCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentCard", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeFromAnimationQueue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeFromAnimationQueue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onNewDeck", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "onNewDeck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeFeedInfo", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "closeFeedInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initializeCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addNextCardToAnimationQueue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addNextCardToAnimationQueue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addCardToAnimationQueue", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addCardToAnimationQueue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrementCardAnimationPositions", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "decrementCardAnimationPositions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCardAnimation", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "advanceCards", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "advanceCards"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "startCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "startCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeCardAnimation", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeCardAnimation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterCardAdvancement", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterCardAdvancement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enrichWord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "enrichWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enrichSentence", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "enrichSentence"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetEnrichedWord", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetEnrichedWord"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "afterGetEnrichedSentence", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "afterGetEnrichedSentence"), _class.prototype), _class);
var _default = exports["default"] = new DeckUI();